/**
 * components/layout/DisruptionBanner.tsx — Phase 3 update.
 *
 * The banner now reads the frozen outbox count and surfaces it inline so
 * the operator sees how many notifications are being held. Otherwise
 * matches the Phase 0 visual language (diagonal stripes, crisp red,
 * fixed 36px height).
 */

import { Siren } from 'lucide-react';
import { useAppStore } from '@/lib/store';
import { selectOutboxCounts } from '@/lib/store/phase3-actions';

export function DisruptionBanner(): React.JSX.Element | null {
const on = useAppStore((s) => s.disruptionMode);
const frozen = useAppStore((s) => s.outbox.filter((e) => e.status === 'FROZEN_DUE_TO_DISRUPTION').length);
if (!on) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      className="relative flex h-9 items-center gap-2.5 overflow-hidden border-b border-ops-danger/40 bg-ops-danger/10 px-6 text-ops-danger"
    >
      <div
        className="pointer-events-none absolute inset-0 opacity-25"
        style={{
          backgroundImage:
            'repeating-linear-gradient(45deg, currentColor 0 1px, transparent 1px 12px)',
        }}
        aria-hidden
      />
      <Siren className="relative h-4 w-4" />
      <span className="relative font-mono text-2xs uppercase tracking-[0.18em]">
        Disruption mode
      </span>
      <span className="relative text-xs">
        notifications frozen · alternate SLA in effect · ops queue priority elevated
      </span>
      <span className="relative ml-auto rounded-sm border border-ops-danger/40 bg-ops-danger/10 px-2 py-0.5 font-mono text-2xs uppercase tracking-wider">
        {frozen} held
      </span>
    </div>
  );
}
